import { render, staticRenderFns } from "./MailTypePreviewModal.vue?vue&type=template&id=02487da7&scoped=true"
import script from "./MailTypePreviewModal.vue?vue&type=script&lang=js"
export * from "./MailTypePreviewModal.vue?vue&type=script&lang=js"
import style0 from "./MailTypePreviewModal.vue?vue&type=style&index=0&id=02487da7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02487da7",
  null
  
)

export default component.exports